import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { AppProvider } from "./context";
import App from "./App";
import "./styles.css";
import "./feature-overrides.css";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <AppProvider>
      <App />
    </AppProvider>
  </StrictMode>,
);
